import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  justify-content: center;
  align-self: center;
  margin: 10px auto;
  display: flex;
  width: 100%;
`;

export const FormWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  align-self: center;
  margin: 0 auto;
`

export const Label = styled.p`
  margin: 2px 5px 0 0;
`;

export const SoldOnlyContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SelectBox = styled.select`
  padding: 10px;
  width: 150px;
  text-align: center;
  margin: 5px 5px;
`;

